import Slider from "@mui/material/Slider";
import { styled, width } from "@mui/system";
const DoubleSlider = styled(Slider)(({ theme }) => ({
  color: "rgb(110 155 71)",
  "& .MuiSlider-thumb": {
    backgroundColor: "rgb(110 155 71)",
    width: "10px",
    height: "10px",
    "&.Mui-active, &.Mui-focusVisible": {
      boxShadow: "none",
    },
    "&:hover": {
      boxShadow: "0 0 0 7px rgb(110 155 71 / 0.4)",
    },
  },
  "& .MuiSlider-rail": {
    backgroundColor: "rgb(110 155 71 / 0.8)",
  },

  "& .MuiSlider-valueLabel": {
    color: "#fff",
    background: "rgb(110 155 71)",
    boxShadow: "-1px 3px 8px 2px rgb(0 0 0 / 15%)",
    fontSize: ".65rem",
  },
  "& .MuiSlider-mark": {
    backgroundColor: "#cacaca",
  },
}));

export { DoubleSlider };
